module.exports = "/cyber/_next/static/images/BannerTabletFOG-12be7882f79d187d05d2313154d422d8.jpg";